import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import mixpanel from 'mixpanel-browser';
import { getRDTRKCookie } from './services/RDstation'
import MixpanelProvider from './mixpanel-hook/mixpanel-provider'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

mixpanel.init('12389351e65fc86e69795b2362fc4ce9', {debug: true});
const BrowserId = getRDTRKCookie().id
mixpanel.identify(BrowserId)
mixpanel.track('Acessou o Planejador de imposto de renda');
mixpanel.people.increment("Acesso ao planejador de imposto de renda");

ReactDOM.render(<React.StrictMode>
  <MixpanelProvider token={'12389351e65fc86e69795b2362fc4ce9'}>
    <App/>
  </MixpanelProvider>
</React.StrictMode>, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();